import { z } from "zod";

export const subpoenaSchema = z.object({
  label: z.string(),
  subpoena_type: z.string(),
});

export type AddSubpoenaForm = z.infer<typeof subpoenaSchema>;

export enum FileRequestSourceType {
  SUBPOENA_INTERNAL = "subpoena-internal",
  JSONL = "jsonl",
  FORCED_MATCHING = "forced-matching",
  WALLET = "wallet",
}

export const addSubpoenaFileRequestSchema = z.object({
  fileName: z.string().optional(),
  source: z.string().optional(),
  sourceType: z.nativeEnum(FileRequestSourceType),
  subpoenaType: z.string().optional(),
  label: z.string().optional(),
  integrationId: z.string().optional(),
});

export type AddSubpoenaFileRequest = z.infer<
  typeof addSubpoenaFileRequestSchema
>;

export type SubSource = {
  name: string;
  type: string;
};

export const genericCsvSchema = z.object({
  label: z.string(),
});

export type AddGenericCsvForm = z.infer<typeof genericCsvSchema>;

export const jsonLFileSchema = z.object({
  label: z.string(),
  walletAddress: z.string().optional(),
});

export const publicAddressSchema = z.object({
  walletAddress: z.string(),
  source: z.string(),
  label: z.string(),
  integrationId: z.string(),
  sourceType: z.nativeEnum(FileRequestSourceType),
});

export type AddJsonLFileSchemaForm = z.infer<typeof jsonLFileSchema>;

export type AddPublicAddressSchemaForm = z.infer<typeof publicAddressSchema>;
